import moment from "moment";
import { HC_PROFESSION, IT_PROFESSION } from "./constant/JobConstants";

export const setCookie = (cookieName, cookieValue, expiryDays) => {
  const d = new Date();
  d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
};

export function deleteOneCookie(cname) {
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax; Secure`;
}

export function replaceGigWithJob(text) {
  try {
    if (typeof text !== "string") return text;

    return text.replace(/\bgigs?\b/gi, (match) => {
      switch (match) {
        case "gig":
          return "job";
        case "gigs":
          return "jobs";
        case "Gig":
          return "Job";
        case "Gigs":
          return "Jobs";
        default:
          return match;
      }
    });
  } catch (error) {
    console.error("Error in replaceGigWithJob:", error);
    return text;
  }
}

export const getCookie = (cookieName) => {
  let name = cookieName + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

export const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};
export function formatDate(dateString) {
  try {
    const date = moment(dateString);
    if (!date.isValid()) return "N/A";
    return date.format("YYYY-MM-DD");
  } catch (err) {
    console.error("Invalid date:", dateString, err);
    return "N/A";
  }
}
// export function formatDate(dateString) {
//   try {
//     const date = moment(dateString);
//     const _date = new Date(date.format("MMM DD, YYYY").toString());
//     return _date.toISOString().split("T")[0];
//   } catch {
//     return 'N/A';
//   }
// }
export function formatDateWithDay(dateString) {
  const date = moment(dateString);
  if (!date.isValid()) return "N/A";
  return date.format("ddd MMMM D"); // e.g. "Tue July 8"
}

export function convertMsToHoursMinutes(ms) {
  try {
    if (!ms) throw ms;
    const totalMinutes = Math.floor(ms / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  } catch {
    return "N/A";
  }
}

export function getOvertimeFromMs(ms) {
  try {
    if (!ms) throw ms;
    const eightHoursMs = 8 * 60 * 60 * 1000;
    if (ms <= eightHoursMs) return "0h 0m";
    const overtimeMs = ms - eightHoursMs;
    const totalMinutes = Math.floor(overtimeMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  } catch {
    return "N/A";
  }
}

export const toReadableTime = (timestamp) => {
  try {
    const time = moment(timestamp);
    if (!time.isValid()) return "Invalid time";
    return time.format("h:mm a");
  } catch (error) {
    return "Invalid time";
  }
};
export const clearAllCookies = () => {
  var cookies = document.cookie.split("; ");
  for (var c = 0; c < cookies.length; c++) {
    var d = window.location.hostname.split(".");
    while (d.length > 0) {
      var cookieBase =
        encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
        "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
        d.join(".") +
        " ;path=";
      var p = window.location.pathname.split("/");
      document.cookie = cookieBase + "/";
      while (p.length > 0) {
        document.cookie = cookieBase + p.join("/");
        p.pop();
      }
      d.shift();
    }
  }
};

const deleteCookie = (name) => {
  setCookie(name, "", -1);
};

const deleteAllCookies = async () => {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++)
    deleteCookie(cookies[i].split("=")[0]);
};

const deleteLocalStorage = async () => {
  const RememberMe = localStorage.getItem("RememberMe");
  const Email = localStorage.getItem("Email");
  const password = localStorage.getItem("password");

  localStorage.clear();
  sessionStorage.clear();

  if (RememberMe === "true") {
    localStorage.setItem("RememberMe", RememberMe);
    localStorage.setItem("Email", Email);
    localStorage.setItem("password", password);
  }
};

export const clearAll = async () => {
  deleteLocalStorage();
  deleteAllCookies();
};

export const GetQueryParams = (query = null) => {
  return (
    decodeURIComponent(window.location.search)
      .replace("?", "")
      // get array of KeyValue pairs
      .split(/&(?!n)/)
      // Decode values
      .map((data) => {
        let [key, val] = data.split("=");
        return [key, decodeURIComponent(val || "")];
      })
      // array to object
      .reduce((result, [key, val]) => {
        result[key] = val;
        return result;
      }, {})
  );
};

export const GetEditQueryParams = (query = null) => {
  const search = decodeURIComponent(query ?? window.location.search).replace(
    /^\?/,
    ""
  );
  const rawPairs = search.split("&");

  const repairedPairs = [];
  for (let i = 0; i < rawPairs.length; i++) {
    const part = rawPairs[i];
    if (!part.includes("=") && repairedPairs.length) {
      repairedPairs[repairedPairs.length - 1] += "&" + part;
    } else {
      repairedPairs.push(part);
    }
  }

  const structuredValue = repairedPairs
    .map((pair) => {
      const [key, val] = pair.split("=");
      let decodedVal = decodeURIComponent(val || "");

      if (decodedVal === "true") decodedVal = true;
      else if (decodedVal === "false") decodedVal = false;
      else if (decodedVal === "null") decodedVal = null;
      else if (decodedVal === "undefined") decodedVal = undefined;
      else if (!isNaN(decodedVal) && decodedVal.trim() !== "")
        decodedVal = Number(decodedVal);

      if (typeof decodedVal === "string" && /^[\[{].*[\]}]$/.test(decodedVal)) {
        try {
          decodedVal = JSON.parse(decodedVal);
        } catch {}
      }

      return [key, decodedVal];
    })
    .reduce((acc, [key, val]) => {
      acc[key] = val;
      return acc;
    }, {});

  return structuredValue;
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || typeof phoneNumber !== "string") {
    return "";
  }

  // Remove any non-digit characters from the phone number
  const digitsOnly = phoneNumber.replace(/\D/g, "");

  // Extract the country code and remaining digits
  let country_code = "";
  let remaining_digits = "";

  // Check if there are at least 10 digits in the phone number
  if (digitsOnly.length >= 10) {
    country_code = digitsOnly.slice(0, digitsOnly.length - 10);
    remaining_digits = digitsOnly.slice(digitsOnly.length - 10);
  } else {
    // If less than 10 digits, consider everything as remaining digits
    remaining_digits = digitsOnly;
  }

  // Check if the remaining digits have the correct length (10 digits)
  if (remaining_digits.length !== 10) {
    console.error(
      "Invalid phone number. The remaining digits should be 10 digits long."
    );
    return ""; // Return an empty string or handle the error as needed
  }

  // Format the phone number as desired
  const formattedNumber = `${country_code ? "+" + country_code : ""
    }(${remaining_digits.slice(0, 3)}) ${remaining_digits.slice(
      3,
      6
    )}-${remaining_digits.slice(6)}`;

  return formattedNumber;
};

export const getFullStateName = (name) => {
  const data = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
    AS: "American Samoa",
    GU: "Guam",
    MH: "Marshall Islands",
    FM: "Micronesia",
    MP: "Northern Marianas",
    PW: "Palau",
    PR: "Puerto Rico",
    VI: "Virgin Islands",
  };
  return data[name];
};

export const getQuery = (key) => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key);
  } catch (error) {
    console.warn("Error", error);
  }
};

export const isNull = (value) => {
  return [null, undefined, "", 0, false, "false", "null"].includes(value);
};

export const getPictureUrl = (pictureUrl = "") => {
  try {
    if (!pictureUrl) return;
    if (pictureUrl?.charAt(0) === "/") {
      return `${process.env.REACT_APP_S3_URL}${pictureUrl}`;
    } else {
      return `${process.env.REACT_APP_S3_URL}/${pictureUrl}`;
    }
  } catch {
    return pictureUrl;
  }
};

export const addQuery = (key, value) => {
  try {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    return searchParams.toString();
  } catch (error) {
    return window.location.search;
  }
};

export function convertDate(dateStr) {
  const moment = require("moment");
  try {
    if (!dateStr) return "";
    const parsedDate = moment(dateStr);
    const formattedDate = parsedDate.format("MMM DD, YYYY");
    return formattedDate;
  } catch (error) {
    console.warn(error);
    return "";
  }
}

export const getDeepCopy = (value) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (error) {
    return value;
  }
};

export function getRelativeTime(dateValue) {
  try {
    const moment = require("moment");
    let momentDate;

    if (moment(dateValue, moment.ISO_8601, true).isValid()) {
      momentDate = moment(dateValue);
    } else {
      momentDate = moment(parseInt(dateValue, 10));
    }
    return momentDate.fromNow();
  } catch (error) {
    return "Invalid Date";
  }
}

export function getValueFromURLSearchParams(key, url = window.location) {
  try {
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);
    const value = params.get(key);
    if (value) {
      const decodedValue = decodeURIComponent(value);
      if (decodedValue.startsWith("[") && decodedValue.endsWith("]")) {
        try {
          return JSON.parse(decodedValue);
        } catch (e) {
          console.error("Error parsing JSON:", e);
          return null;
        }
      }
      return [decodedValue.replace(/\+/g, " ")];
    }
    return null;
  } catch (e) {
    console.error("Invalid URL or error processing URL:", e);
    return null;
  }
}

export const getFullName = (firstName, lastName) => {
  try {
    return `${firstName ? firstName : ""} ${lastName ? lastName : ""}`.trim();
  } catch (error) {
    return "";
  }
};

export const EXPERIENCE_LEVELS = [
  {
    _id: "63ae878e60f52c72dbcba6b3",
    ExperienceLevelId: 1,
    ExperienceLevelCode: "less",
    ExperienceLevelName: "Less than 1 year",
    MinVal: 0,
    MaxVal: 1,
    SortOrder: 1,
    Created: "2015-07-20T21:23:36.160Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.160Z",
    ModifiedBy: 0,
  },
  {
    _id: "63ae878e60f52c72dbcba6b4",
    ExperienceLevelId: 2,
    ExperienceLevelCode: "2",
    ExperienceLevelName: "1-2 years",
    MinVal: 1,
    MaxVal: 2,
    SortOrder: 2,
    Created: "2015-07-20T21:23:36.163Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.163Z",
    ModifiedBy: 0,
  },
  {
    _id: "63ae878e60f52c72dbcba6b5",
    ExperienceLevelId: 3,
    ExperienceLevelCode: "3-5",
    ExperienceLevelName: "3-5 years",
    MinVal: 3,
    MaxVal: 5,
    SortOrder: 3,
    Created: "2015-07-20T21:23:36.167Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.167Z",
    ModifiedBy: 0,
  },
  {
    _id: "6402a5d64c35f236aabb96cb",
    ExperienceLevelId: 4,
    ExperienceLevelCode: "6",
    ExperienceLevelName: "6-10 years",
    MinVal: 6,
    MaxVal: 10,
    SortOrder: 4,
    Created: "2015-07-20T21:23:36.167Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.167Z",
    ModifiedBy: 0,
  },
  {
    _id: "63ae878e60f52c72dbcba6b7",
    ExperienceLevelId: 5,
    ExperienceLevelCode: "more",
    ExperienceLevelName: "More than 10 years",
    MinVal: 10,
    MaxVal: 100,
    SortOrder: 5,
    Created: "2015-07-20T21:23:36.170Z",
    CreatedBy: 0,
    Modified: "2015-07-20T21:23:36.170Z",
    ModifiedBy: 0,
  },
];
export function capitalizeFirstLetter(string) {
  try {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  } catch {
    return "";
  }
}

export const getCompanyName = (profile) => {
  try {
    const name =
      profile?.PreferredName ||
      profile?.CompanyName ||
      (profile?.FirstName
        ? `${profile.FirstName} ${profile?.LastName || ""}`
        : null);

    return name ? capitalizeFirstLetter(name.trim()) : null;
  } catch {
    return null;
  }
};

export const generateFinalUrl = (
  basePath = "/job-filters",
  accumulatedFilters
) => {
  const searchParams = new URLSearchParams(accumulatedFilters);
  return `${basePath}?${searchParams.toString()}`;
};

export function isPlainInteger(value) {
  if (value === null || value === undefined || value === "" || value === 0)
    return true;

  const str = String(value).trim();

  // Allow empty input (user clearing the field)
  if (str === "") return false;

  // Block scientific notation, plus, minus, decimal points
  if (/e|\+|-|\./i.test(str)) return false;

  // Must be all digits (no letters, no symbols)
  if (!/^\d+$/.test(str)) return false;

  return true;
}

export function formatTimeToZone(isoString, timeZone) {
  const date = new Date(isoString);

  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}

export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export const getGigDetails = () => {
  try {
    const gigDetail = JSON.parse(localStorage.getItem("gigDetail"));
    if (gigDetail) {
      return gigDetail;
    } else {
      return null;
    }
  } catch { }
};

export const decodeSpecialCharacter = (value) => {
  try {
    if (typeof value === "string" || typeof value === "number") {
      return String(value).replace(/-\*/g, "&");
    }
    return value;
  } catch (error) {
    console.warn(error);
    return value;
  }
};

export const negativeBidStatus = [
  "Offer Declined",
  "Canceled",
  "Off Billing",
  "Interview Cancelled",
  "Declined",
  "Terminated",
  "Interview Declined",
  "Retracted",
];


export const formatNumber = (digits) => {
  if (!digits) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 13)}`;
};

export const COMPANY_SIZES = [
  { label: "Only me", value: "Only me" },
  { label: "2 - 10 employees", value: "2 - 10" },
  { label: "10 - 50 employees", value: "10 - 50" },
  { label: "50 - 200 employees", value: "50 - 200" },
  { label: "200 - 500 employees", value: "200 - 500" },
  { label: "500 - 1k employees", value: "500 - 1000" },
  { label: "1k - 5k employees", value: "1000 - 5000" },
  { label: "5k - 10k employees", value: "5000 - 10000" },
  { label: "10k+ employees", value: "10000+" },
];

export const CATEGORIES = [
  { value: "technology", label: "Technology", Type: "Non-HC" },
  { value: "finance", label: "Finance", Type: "Non-HC" },
  { value: "doctor", label: "Doctor", Type: "HC" },
];

export const contractOptions = [
  { IdealContractLengthId: 1, IdealContractLengthName: "1 month", IdealContractLengthValue: 1 },
  { IdealContractLengthId: 2, IdealContractLengthName: "2 months", IdealContractLengthValue: 2 },
  { IdealContractLengthId: 3, IdealContractLengthName: "3 months", IdealContractLengthValue: 3 },
  { IdealContractLengthId: 4, IdealContractLengthName: "4 months", IdealContractLengthValue: 4 },
  { IdealContractLengthId: 5, IdealContractLengthName: "5 months", IdealContractLengthValue: 5 },
  { IdealContractLengthId: 6, IdealContractLengthName: "6 months", IdealContractLengthValue: 6 },
  { IdealContractLengthId: 7, IdealContractLengthName: "7 months", IdealContractLengthValue: 7 },
  { IdealContractLengthId: 8, IdealContractLengthName: "8 months", IdealContractLengthValue: 8 },
  { IdealContractLengthId: 9, IdealContractLengthName: "9 months", IdealContractLengthValue: 9 },
  { IdealContractLengthId: 10, IdealContractLengthName: "10 months", IdealContractLengthValue: 10 },
  { IdealContractLengthId: 11, IdealContractLengthName: "11 months", IdealContractLengthValue: 11 },
  { IdealContractLengthId: 12, IdealContractLengthName: "1 year", IdealContractLengthValue: 12 },
  { IdealContractLengthId: 13, IdealContractLengthName: "1+ years", IdealContractLengthValue: 13 },
  { IdealContractLengthId: 14, IdealContractLengthName: "Negotiable", IdealContractLengthValue: 14 },
  { IdealContractLengthId: 15, IdealContractLengthName: "13 weeks", IdealContractLengthValue: 15 },
  { IdealContractLengthId: 16, IdealContractLengthName: "1 Week", IdealContractLengthValue: 16 },
  { IdealContractLengthId: 17, IdealContractLengthName: "6 weeks", IdealContractLengthValue: 17 },
  { IdealContractLengthId: 18, IdealContractLengthName: "12 weeks", IdealContractLengthValue: 18 },
];


export const skillGigPercentage = 10;

export const PAYROLL_PERCENTAGES = {
  w2: { hourly: 18, weekly: 12 },
  c2c: { hourly: 5, weekly: 10 }
};
export const getProfessionCode = () => {
  try {
    let userProfile = JSON.parse(localStorage.getItem("userProfile"));
    return userProfile?.Professions?.ProfessionCode;
  } catch {}
};

const getNormalizedProfessionCode = (professionCode) => {
  if (professionCode !== undefined && professionCode !== null) {
    return String(professionCode).toUpperCase();
  }
  return String(getProfessionCode() || "").toUpperCase();
};

export const isHC = (professionCode) => {
  try {
    return getNormalizedProfessionCode(professionCode) === HC_PROFESSION;
  } catch (error) {
    return false;
  }
};

export const isNonHC = (professionCode) => {
  try {
    return getNormalizedProfessionCode(professionCode) === IT_PROFESSION;
  } catch (error) {
    return false;
  }
};

export const isIT = (professionCode) => {
  return isNonHC(professionCode);
};

// Emoji and pictographic symbols are not allowed in job content — they are noise for the
// NLP/AI talent search and render inconsistently across the app. Covers dingbats/misc
// symbols (2300-27BF, e.g. the check mark), arrows-and-shapes (2B00-2BFF), the emoji
// planes (1F000-1FAFF), flags, keycaps, variation selectors and ZWJ joiners.
const EMOJI_PATTERN =
  /[\u{2300}-\u{27BF}\u{2B00}-\u{2BFF}\u{1F000}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}\u{FE0F}\u{200D}\u{20E3}]/gu;

export const stripEmoji = (text = "") => {
  const value = String(text ?? "");
  const cleaned = value.replace(EMOJI_PATTERN, "");
  if (cleaned === value) return value;

  // an emoji is usually followed by a space ("✅ Expert-level Python"), so tidy up the
  // gap it leaves behind instead of pushing every line in by one character
  return cleaned.replace(/^[ \t]+/gm, "").replace(/[ \t]{2,}/g, " ");
};

export const normalizeDescriptionLines = (text = "") => {
  try {
    const normalized = String(text ?? "")
      .replace(/\r\n?/g, "\n")
      .replace(/\t/g, " ")
      .replace(/[\u2022\u25CF\u25E6\u25AA]/g, "\n* ")
      .replace(/\n\s*[-\u2013\u2014]\s+/g, "\n* ")
      .replace(/\s{2,}/g, " ")
      .trim();

    const out = [];
    for (const rawLine of normalized.split("\n")) {
      const line = rawLine.trim();
      if (!line) continue;

      const startsNewPoint = /^[-*\u2013\u2014]/.test(line);
      const cleanLine = line.replace(/^[-*\u2013\u2014]+\s*/, "").trim();
      if (!cleanLine) continue;

      if (!startsNewPoint && out.length > 0) {
        out[out.length - 1] = `${out[out.length - 1]} ${cleanLine}`
          .replace(/\s{2,}/g, " ")
          .trim();
      } else {
        out.push(cleanLine);
      }
    }

    return out;
  } catch (error) {
    console.error("Error normalizing description lines:", error);
    if (!text) return [];
    return String(text)
      .split(/\r\n?|\n/)
      .map((line) => line.trim())
      .filter(Boolean);
  }
};

// Whether a job with no location at all should read as "Remote".
//
// Only ever consulted for a job that carries no location: a saved location always
// speaks for itself, so this returns false as soon as one is found.
// With none, WorkplacePolicy decides when the job has one — it comes through as
// "fully-remote", "Remote", "hybrid", "on-prem" or "Onsite". Jobs created through
// the app save no policy at all, and the job form requires a location for every
// type except Remote, so for those a missing location means Remote. That does not
// hold for imported jobs (AutoLoaded) — plenty carry neither a policy nor a
// location and are not remote — so they stay out of the inference.
export const isRemoteJobLocation = (job) => {
  const hasLocation = [
    job?.Location?.LocationWithCountry,
    job?.Location?.Location,
    job?.Location?.LocationLong,
    job?.location,
    job?.Cities?.CityName,
    job?.CityName,
    job?.RegionCode,
  ].some((value) => String(value ?? "").trim());
  if (hasLocation) return false;

  const policy = String(job?.WorkplacePolicy ?? "").trim();
  if (policy) return /remote/i.test(policy);

  return !job?.AutoLoaded;
};
